import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWalletAccountValidateOtpCollectionResponse } from '../../../data/repository/fs-wallet-account/http-fs-wallet-account.collection';
import { UseCase } from '../../base/usecase';
import { FSWalletAccountRepository } from '../../repository/fs-wallet-account.repository';
import { OtpValidateDTO } from './interface/otp-validate.dto';

@Injectable({
  providedIn: 'root',
})
export class ValidateWalletOtpUsecase
  implements
    UseCase<OtpValidateDTO, HttpWalletAccountValidateOtpCollectionResponse>
{
  constructor(private repository: FSWalletAccountRepository) {}

  execute(
    data: OtpValidateDTO
  ): Observable<HttpWalletAccountValidateOtpCollectionResponse> {
    return this.repository.ValidateWalletOtp(data);
  }
}
